import React, { useState } from 'react';


const Home = () => {
    let Links =[
      {name:"HOME",link:"#home"},
      {name:"ABOUT",link:"#about"},
      {name:"PROJECTS",link:"#projects"},
      {name:"SKILLS",link:"#skills"},
      {name:"CONTACT",link:"#contact"}
    ];
    let [open,setOpen]=useState(false);
  return (

    <section id='home' className=" md:px-14 text-slate-100 bg-gradient-to-r from-fuchsia-600 to-violet-500">
    <div className=' w-full fixed md:absolute top-0 left-0'>
      <div className='flex items-center justify-between bg-white py-2 md:mb-6 md:px-10 px-7'>
          <div className='font-bold text-2xl cursor-pointer flex items-center font-[Poppins] 
               text-gray-800'>
                <h1><span className="text-purple-400">O</span>shela</h1>
          </div>
      
          <div onClick={()=>setOpen(!open)} className='text-3xl cursor-pointer md:hidden'>
          <ion-icon name={open ? 'close':'menu'}></ion-icon>
          </div>

          <ul className={`md:flex md:items-center md:pb-0  absolute md:static bg-white  right-0 w-2/4 md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${open ? 'top-10 ':'top-[-490px]'}`}>
            {
              Links.map((link)=>(
                <li key={link.name} className='md:ml-8 text-xl md:my-0 my-7'>
                  <a href={link.link} className='text-gray-800 hover:text-fuchsia-600 duration-500'>{link.name}</a>
                </li>
              ))
            }
          
          </ul>
      </div>
      
    </div>
    <div className=" mt-8 m-4 py-14 md:px-14 font-sans ">
    <h1 className="text-2xl md:text-4xl font-bold">Hello!<span className="">👋🏾</span></h1>
    
    <div className="wrapper grid justify-start">
        <div className="typing-demo text-xl md:text-3xl">
            I'm Abimiku <span className=""> Oshela</span>
        </div>
    </div>
    <div className="grid justify-start">
        
        Software Developer, UI/UX Designer, Frontend Engineer, Graphic designer
       
       
    </div>

</div>

<hr />
</section>
  )
}
export default Home;

